import React from 'react';

const SegmentedControl = ({ name, options, value, onChange }) => (
  <div className="flex rounded-lg border border-veit-border bg-white p-1 gap-1 shadow-sm">
    {options.map((opt) => {
      const selected = value === opt;
      return (
        <button
          key={opt}
          type="button"
          onClick={() => onChange({ target: { name, value: opt } })}
          className={`flex-1 py-2 px-2 rounded-md text-xs font-semibold transition-all duration-150 ${
            selected 
              ? 'bg-veit-secondary text-white shadow-sm' 
              : 'text-veit-gray hover:text-veit-navy hover:bg-veit-light'
          }`}
        >
          {opt}
        </button>
      );
    })}
  </div>
);

export default SegmentedControl;